export default {
    visitor: 'ผู้เยี่ยมชม',
    searchBy: 'ค้นหาตามรายชื่อผู้เยี่ยมชม',
    search: 'ค้นหา',
    createNewVisitor: 'สร้างผู้เยี่ยมชม',
    visitorName: 'ชื่อผู้เยี่ยมชม',
    contact: 'ติดต่อ',
    contactNo: 'เบอร์โทรศัพท์',
    joinedDate: 'วันที่เข้าร่วม',
    access: 'อนุญาตใช้งาน',
    status: 'สถานะ',
    active: 'เปิด',
    deactive: 'ปิด',
    allStatus: 'สถานะทั้งหมด',
    deleteVisitor: 'ลบผู้เยี่ยมชม',
    congratulation: 'ยินดีด้วย',
    msgDeleteSuccess: 'ผู้เยี่ยมชมถูกลบเเล้ว',
    questionDelete: 'คุณเเน่ใจว่าต้องการที่จะลบผู้เยียมชม "$Name" ?'
}
